import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { CommonSelect } from "../common";
import { CommonButton } from "../common/commonButton";
import { toast } from "react-toastify";
import { Box, Grid, FormLabel, TextField, Checkbox, Collapse, CircularProgress, Tooltip, IconButton, Typography } from "@mui/material";
import instance from "../../redux/api";
import MUIDataTable from "mui-datatables";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { getWorkflowList, userManagementGet, workstepUserUpdate } from "../../Services/api";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import './workflow.css';
import { AutoCompleteSelect } from "./AutoCompleteSelect";
import DialogBox from "../common/dialog";
import CloseIcon from "@mui/icons-material/Close";
import { commonToast } from "../common";
import {
  primaryButtonStyle,
  secondaryButtonStyle,
  submitButtonStyle,
  primaryButtonHoverColor,
  primaryBlueColor,
} from "../common/commonButtonStyles";
import "../common/commonPageStyles.css";


export default function WorkflowContainer() {
  const toggle = useSelector((state) => state.toggleSideMenu);
  const { userData } = useSelector((state) => state?.user);
  const [row, setRow] = useState({ user: "" });
  const [selectedWorkstep, setSelectedWorkstep] = useState({
    selectedWorkflowId: "",
    selectedWorkstepId: "",
    selectedWorkflowName: "",
    selectedWorkstepName: ""
  });
  const [deleteUser, setDeleteUser] = useState({
    workflowId : "",
    workstepId: "",
    userId: ""
  });
  const [tableRows, setTableRows] = useState([]);
  const [transformedData, setTransformedData] = useState([]);
  const [isApiCallInprogress, setIsApiCallInprogress] = useState(false);
  const [isOpenAddUserDialog, setIsOpenAddUserDialog] = useState(false);
  const [activeUsersList, setActiveUsersList] = useState([]);
  const [open, setOpen] = useState(false);
  const [expandedWorkflowRows, setExpandedWorkflowRows] = useState([]);
  const [expandedWorkstepRows, setExpandedWorkstepRows] = useState({});

  const UserAuthorisation =
    userData?.user_permissions?.permissions_list['Admin Table Maintenance'];

  const Container = {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    gap: 0,
    height: "calc(100vh - 180px)",
    maxHeight: "calc(100vh - 180px)",
    overflow: "hidden",
    position: "relative",
  };

  useEffect(() => {
    getActiveUsers();
  }, []);


  useEffect(() => {
    loadData();
  }, []);

  const getActiveUsers = async () => {
    const response = await instance.get(`${userManagementGet}?status=Active`);
    setActiveUsersList(response.data && response.data.length ? response.data : [])
  }

  const loadData = async () => {
    try {
      setIsApiCallInprogress(true);
      const resp = await instance.get(getWorkflowList);
      setIsApiCallInprogress(false);
      if (resp.status === 200) {
        const sortedData = resp.data.sort((a, b) => b.id - a.id);
        setTableRows(sortedData);
        const columnKeys = columns.map(column => column.field);
        const transformedData = sortedData?.map(item =>
          columnKeys.map(key => item[key] !== undefined ? item[key] : null)
        );
        console.log("transformedData", transformedData)
        setTransformedData(transformedData);
      } else {
        setTableRows([]);
        setTransformedData([]);
      }
    } catch (err) {
      setIsApiCallInprogress(false);
      console.error("err", err);
    }
  };

  const handleCloseAddUserDialog = () => {
    setIsOpenAddUserDialog(false);
    setRow({ ...row, user: "" });
    setSelectedWorkstep({
      selectedWorkflowId: "",
      selectedWorkstepId: "",
      selectedWorkflowName: "",
      selectedWorkstepName: ""
    });
  }

  const handleCloseDeleteUserDialog = () => {
    setOpen(false);
    setDeleteUser({
      workflowId: "",
      workstepId: "",
      userId: ""
    });
  }

  const cleanupTransactionData = () => {
    handleCloseAddUserDialog();
    handleCloseDeleteUserDialog();
    loadData();
  };

  const handleAddUser = async () => {
    try {
      const selectedUserId = row?.user?.id;
      const worksteps = tableRows?.find(row => row.id === selectedWorkstep.selectedWorkflowId)?.workflow_step || []
      const workstep = worksteps?.find(row => row.id === selectedWorkstep.selectedWorkstepId) || {}
      const userIds = workstep?.user?.map(user => user.id) || []

      const workflowIndex = tableRows?.findIndex(row => row.id === selectedWorkstep.selectedWorkflowId);
      const workstepIndex = worksteps?.findIndex(row => row.id === selectedWorkstep.selectedWorkstepId);
      setExpandedWorkflowRows([workflowIndex]);
      setExpandedWorkstepRows({ [selectedWorkstep.selectedWorkflowId]: [workstepIndex] });
      if (userIds.includes(selectedUserId)) {
        commonToast("error", "User already exists in workstep.");
        return
      }

      const payload = { user_id: row.user.id };
      const response = await instance.patch(`${workstepUserUpdate}${selectedWorkstep.selectedWorkstepId}/`, payload);
      if (response) {
        commonToast("success", "User added successfully !");
        cleanupTransactionData();
      }
    }
    catch (err) {
      commonToast("error", "User addition failed. Please try again.");
      handleCloseAddUserDialog()
    }
  }

  const confirmDelete = (workflowId, workstepId, userId, userLength) => {
    if (userLength <= 1) {
      commonToast("error", "Atleast one user should remain in the workstep");
      return;
    }
    setDeleteUser({
      workflowId: workflowId,
      workstepId: workstepId,
      userId: userId
    });
    setOpen(true);
  }

  const handleDeleteUserConfirmed = async () => {
    try {
      const workflowIndex = tableRows?.findIndex(row => row.id === deleteUser.workflowId);
      const worksteps = tableRows?.find(row => row.id === deleteUser.workflowId)?.workflow_step || [];
      const workstepIndex = worksteps?.findIndex(row => row.id === deleteUser.workstepId);
      setExpandedWorkflowRows([workflowIndex]);
      setExpandedWorkstepRows({ [deleteUser.workflowId]: [workstepIndex] });
      let queryParams = ``;
      if (deleteUser.userId) {
        queryParams = `?user_id=${deleteUser.userId}`
      }

      const response = await instance.delete(`${workstepUserUpdate}${deleteUser.workstepId}/${queryParams}`);
      if (response) {
        commonToast("success", "User deleted successfully !");
      }
      cleanupTransactionData();
    }
    catch (err) {
      commonToast("error", "User deletion failed. Please try again.");
      handleCloseDeleteUserDialog()
    }
  }

  const handleDeleteUserCancelled = () => {
    const workflowIndex = tableRows?.findIndex(row => row.id === deleteUser.workflowId);
    const worksteps = tableRows?.find(row => row.id === deleteUser.workflowId)?.workflow_step || [];
    const workstepIndex = worksteps?.findIndex(row => row.id === deleteUser.workstepId);
    setExpandedWorkflowRows([workflowIndex]);
    setExpandedWorkstepRows({ [deleteUser.workflowId]: [workstepIndex] });
    handleCloseDeleteUserDialog();
  }
  const handleAddUserCancelled = () => {
    const worksteps = tableRows?.find(row => row.id === selectedWorkstep.selectedWorkflowId)?.workflow_step || [];
    const workflowIndex = tableRows?.findIndex(row => row.id === selectedWorkstep.selectedWorkflowId);
    const workstepIndex = worksteps?.findIndex(row => row.id === selectedWorkstep.selectedWorkstepId);
    setExpandedWorkflowRows([workflowIndex]);
    setExpandedWorkstepRows({ [selectedWorkstep.selectedWorkflowId]: [workstepIndex] });
    handleCloseAddUserDialog();
  }

  const handleUserChange = (event, value, reason) => {
    if (reason === "clear") {
      setRow({ ...row, user: "" })
    }
    else {
      setRow({ ...row, user: value })
    }
  }

  const options = {
    filter: true,
    onFilterChange: (changedColumn, filterList) => {
      console.log(changedColumn, filterList);
    },
    selectableRows: "none", // Disable default selectable rows
    filterType: "dropdown",
    pagination: false,
    expandableRows: true,
    expandableRowsHeader: false,
    download: false,
    print: false,
    search: false,
    filter: false,
    viewColumns: false,
    serverSide: true,
    selectToolbarPlacement: 'none',
    renderExpandableRow: (rowData, rowMeta) => renderExpandableRowForWorkflowSteps(rowData, rowMeta),
    customToolbarSelect: () => {
      return isApiCallInprogress ? <CircularProgress size={24} /> : null;
    },
    textLabels: {
      body: {
        noMatch: isApiCallInprogress ? <CircularProgress size={24} /> : "Sorry, no data found",
      },
    },
    rowsExpanded: expandedWorkflowRows,
    onRowExpansionChange: (curExpanded, allExpanded) => {
      const expandedRowsIndexes = allExpanded.map((row) => row.index);
      setExpandedWorkflowRows(expandedRowsIndexes);
    },
  };

  const renderExpandableRowForWorkflowSteps = (rowData, rowMeta) => {
    console.log("rowData", rowData)
    const rowId = rowData[0] || ""; // workflow id
    const worksteps = tableRows?.find(row => row.id === rowId)?.workflow_step?.sort((a, b) => a.id - b.id) || [];
    console.log("worksteps", worksteps)
    const workstepColumnKeys = workstep_columns?.map(column => column.field) || [];
    console.log("workstepColumnKeys", workstepColumnKeys)
    const workstepTransformedData = worksteps?.map(item =>
      workstepColumnKeys.map(key => item[key] !== undefined ? item[key] : null)
    );
    console.log("workstepTransformedData", workstepTransformedData)

    const workstep_options = {
      filter: true,
      onFilterChange: (changedColumn, filterList) => {
        console.log(changedColumn, filterList);
      },
      selectableRows: "none", // Disable default selectable rows
      filterType: "dropdown",
      pagination: false,
      expandableRows: true,
      expandableRowsHeader: false,
      download: false,
      print: false,
      search: false,
      filter: false,
      viewColumns: false,
      serverSide: true,
      selectToolbarPlacement: 'none',
      renderExpandableRow: (rowData, rowMeta) => renderExpandableRowForWorkstepUsers(rowData, rowMeta),
      customToolbarSelect: () => {
        return isApiCallInprogress ? <CircularProgress size={24} /> : null;
      },
      textLabels: {
        body: {
          noMatch: isApiCallInprogress ? <CircularProgress size={24} /> : "Sorry, no data found",
        },
      },
      rowsExpanded: expandedWorkstepRows[rowId],
      onRowExpansionChange: (curExpanded, allExpanded) => {
        const expandedRowsIndexes = allExpanded.map((row) => row.index);
        setExpandedWorkstepRows({ ...expandedWorkstepRows, [rowId]: expandedRowsIndexes });
      },
    };

    return (
      <TableRow>
        <TableCell colSpan={columns.length + 1} sx={{ padding: "16px 0", backgroundColor: "#fafafa" }}>
          <Collapse in={true} timeout="auto" unmountOnExit>
            <TableContainer 
              sx={{ 
                width: "95%", 
                marginLeft: "2.5%",
                backgroundColor: "#ffffff",
                borderRadius: "8px",
                border: "1px solid #e0e0e0",
                boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
              }} 
              component={Paper} 
              className="collapse-table-container"
            >
              <Table aria-label="simple table">
                <MUIDataTable
                  className="table_row_workstep"
                  data={workstepTransformedData}
                  columns={workstep_columns}
                  options={workstep_options}
                />
              </Table>
            </TableContainer>
          </Collapse>
        </TableCell>
      </TableRow>
    );
  };

  const renderExpandableRowForWorkstepUsers = (rowData, rowMeta) => {
    const rowId = rowData[0] || ""; // workstep id
    const workflowId = tableRows?.find(row => row?.workflow_step?.find(workstep => workstep.id === rowId))?.id || "";
    const workflow_steps = tableRows?.find(row => row?.workflow_step?.find(workstep => workstep.id === rowId))?.workflow_step || [];
    const workflow_step = workflow_steps?.find(row => row.id === rowId) || {};
    const users = workflow_step?.user?.sort((a, b) => b.id - a.id) || [];
    return (
      <>
        {
          users.length > 0 && (
            <TableRow>
              <TableCell colSpan={workstep_columns.length + 1} sx={{ padding: "16px 0", backgroundColor: "#f5f5f5" }}>
                <Collapse in={true} timeout="auto" unmountOnExit>
                  <TableContainer 
                    sx={{ 
                      width: "95%", 
                      marginLeft: "2.5%",
                      backgroundColor: "#ffffff",
                      borderRadius: "8px",
                      border: "1px solid #e0e0e0",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                    }} 
                    component={Paper} 
                    className="collapse-table-container"
                  >
                    <Table aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell 
                            className="user_id_column"
                            sx={{
                              backgroundColor: "#f8f9fa",
                              color: "#333",
                              fontWeight: "600",
                              fontSize: "14px",
                              borderBottom: "2px solid #e0e0e0",
                              padding: "12px 16px",
                            }}
                          >
                            User Id
                          </TableCell>
                          <TableCell 
                            className="user_name_column"
                            sx={{
                              backgroundColor: "#f8f9fa",
                              color: "#333",
                              fontWeight: "600",
                              fontSize: "14px",
                              borderBottom: "2px solid #e0e0e0",
                              padding: "12px 16px",
                            }}
                          >
                            User Name
                          </TableCell>
                          <TableCell
                            sx={{
                              backgroundColor: "#f8f9fa",
                              color: "#333",
                              fontWeight: "600",
                              fontSize: "14px",
                              borderBottom: "2px solid #e0e0e0",
                              padding: "12px 16px",
                            }}
                          >
                            Actions
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {users.map((data, index) => (
                          <TableRow 
                            key={index}
                            sx={{
                              borderBottom: "1px solid #f0f0f0",
                              "&:hover": {
                                backgroundColor: "rgba(22, 114, 222, 0.04) !important",
                              },
                              "&:nth-of-type(even)": {
                                backgroundColor: "#fafafa",
                                "&:hover": {
                                  backgroundColor: "rgba(22, 114, 222, 0.04) !important",
                                },
                              },
                            }}
                          >
                            <TableCell
                              sx={{
                                fontSize: "14px",
                                color: "#333",
                                padding: "12px 16px",
                              }}
                            >
                              {data.id}
                            </TableCell>
                            <TableCell
                              sx={{
                                fontSize: "14px",
                                color: "#333",
                                padding: "12px 16px",
                              }}
                            >
                              {data.user_name}
                            </TableCell>
                            <TableCell
                              sx={{
                                fontSize: "14px",
                                color: "#333",
                                padding: "12px 16px",
                              }}
                            >
                              <Tooltip title="Delete">
                                <DeleteIcon 
                                  onClick={() => confirmDelete(workflowId, rowId, data.id, users.length)}
                                  sx={{ color: primaryBlueColor, cursor: "pointer" }}
                                />{" "}
                              </Tooltip>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Collapse>
              </TableCell>
            </TableRow>
          )
        }
      </>
    )
  }

  const columns = [
    {
      field: "id",
      name: "ID",
      headerAlign: "left",
      width: 10,
      maxWidth: 30
    },
    {
      field: "workflow_name",
      name: "Workflow Name",
      headerAlign: "left",
      width: 150,
      options: {
        customBodyRender: (value) => (
          <div style={{ textAlign: 'left' }}>{value}</div>
        ),
      },
    }
  ]

  const workstep_columns = [
    {
      field: "id",
      name: "ID",
      headerAlign: "center",
      width: 10,
      maxWidth: 30
    },
    {
      field: "step_name",
      name: "Step Name",
      headerAlign: "left",
      width: 80,
      options: {
        customBodyRender: (value) => (
          <div style={{ textAlign: 'left' }}>{value}</div>
        ),
      },
    },
    {
      field: "actions",
      type: "actions",
      name: "Actions",
      headerAlign: "left",
      width: 150,
      cellClassName: "actions",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          const rowId = tableMeta?.rowData[0] || "";
          const workstepName = tableMeta?.rowData[1] || "";
          const workflowId = tableRows?.find(row => row?.workflow_step?.find(workstep => workstep.id === rowId))?.id || "";
          const workflowName = tableRows?.find(row => row?.workflow_step?.find(workstep => workstep.id === rowId))?.workflow_name || "";
          return (
            <CommonButton
              text="Add User"
              handleClick={() => {
                setSelectedWorkstep({
                  ...selectedWorkstep,
                  selectedWorkflowId: workflowId,
                  selectedWorkstepId: rowId,
                  selectedWorkflowName: workflowName,
                  selectedWorkstepName: workstepName
                })
                setIsOpenAddUserDialog(true)
              }
              }
              sx={primaryButtonStyle}
              hoverColor={primaryButtonHoverColor}
              className={"add_user_button"}
            />
          )
        }
      }
    },
  ]

  return (
    <>
      <style>
        {`
          /* Override MUIDataTable column headers to match other screens */
          .table_row th,
          .table_row_workstep th {
            background-color: #f8f9fa !important;
            color: #333 !important;
            font-weight: 600 !important;
            border-bottom: 2px solid #e0e0e0 !important;
          }
          .table_row th button,
          .table_row_workstep th button {
            background-color: transparent !important;
            color: #333 !important;
            border-left: 1px solid #e0e0e0 !important;
          }
          .table_row tbody tr:hover,
          .table_row_workstep tbody tr:hover {
            background-color: rgba(22, 114, 222, 0.04) !important;
          }
          .table_row tbody tr:nth-of-type(even),
          .table_row_workstep tbody tr:nth-of-type(even) {
            background-color: #fafafa !important;
          }
          .table_row tbody tr:nth-of-type(even):hover,
          .table_row_workstep tbody tr:nth-of-type(even):hover {
            background-color: rgba(22, 114, 222, 0.04) !important;
          }
        `}
      </style>
      <div style={Container}>
        {/* Main Content Area */}
        <Box className="main-content-area">
          <Box className="page-header-container">
            <Typography variant="h5" className="page-heading">
              Workflow User Management
            </Typography>
          </Box>

          <Box
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              minHeight: 0,
              position: "relative",
              backgroundColor: "#ffffff",
              borderRadius: "12px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              overflow: "hidden",
              transition: "all 0.3s ease",
              border: "1px solid #e0e0e0",
              width: "100%",
            }}
          >
            {isApiCallInprogress ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                  minHeight: "400px",
                }}
              >
                <CircularProgress sx={{ color: primaryBlueColor }} />
              </Box>
            ) : (
              transformedData && (
                <Box 
                  sx={{ 
                    flex: 1, 
                    overflow: "auto", 
                    padding: "20px",
                    "&::-webkit-scrollbar": {
                      width: "8px",
                      height: "8px",
                    },
                    "&::-webkit-scrollbar-track": {
                      background: "#f1f1f1",
                      borderRadius: "10px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#c1c1c1",
                      borderRadius: "10px",
                      "&:hover": {
                        background: "#a8a8a8",
                      },
                    },
                  }}
                >
                  <MUIDataTable
                    className="table_row"
                    data={transformedData}
                    columns={columns}
                    options={options}
                  />
                </Box>
              )
            )}
          </Box>
        </Box>
        <Dialog 
          open={isOpenAddUserDialog} 
          onClose={handleAddUserCancelled}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: "12px",
              boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
            }
          }}
        >
          <DialogTitle
            id="alert-dialog-title" 
            sx={{ 
              cursor: "default", 
              paddingBottom: "0px",
              padding: "20px 24px 16px 24px",
              backgroundColor: "#f8f9fa",
              borderBottom: "1px solid #e0e0e0",
            }}
          >
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Typography
                variant="h6"
                sx={{
                  color: primaryBlueColor,
                  fontWeight: 600,
                  fontSize: "18px",
                  margin: 0,
                }}
              >
                Add User To Workstep
              </Typography>
              <IconButton
                aria-label="close"
                onClick={handleAddUserCancelled}
                sx={{
                  position: "absolute",
                  right: 12,
                  top: 12,
                  color: "#666",
                  "&:hover": {
                    backgroundColor: "rgba(22, 114, 222, 0.1)",
                    color: primaryBlueColor,
                  },
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
          </DialogTitle>
          <DialogContent sx={{ padding: "24px" }}>
            <Grid container spacing={3} sx={{ mt: 0 }}>
              <Grid
                item
                xs={6}
                display={"flex"}
                flexDirection={"column"}
                gap={"8px"}
              >
                <FormLabel
                  sx={{
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#333",
                    marginBottom: "4px",
                  }}
                >
                  Workflow Name
                </FormLabel>
                <TextField
                  value={selectedWorkstep.selectedWorkflowName}
                  disabled={true}
                  size="small"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "#f5f5f5",
                      "& fieldset": {
                        borderColor: "#e0e0e0",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid
                item
                xs={6}
                display={"flex"}
                flexDirection={"column"}
                gap={"8px"}
              >
                <FormLabel
                  sx={{
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#333",
                    marginBottom: "4px",
                  }}
                >
                  Workstep Name
                </FormLabel>
                <TextField
                  value={selectedWorkstep.selectedWorkstepName}
                  disabled={true}
                  size="small"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "#f5f5f5",
                      "& fieldset": {
                        borderColor: "#e0e0e0",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid
                item
                xs={12}
                display={"flex"}
                flexDirection={"column"}
                gap={"8px"}
              >
                <FormLabel
                  sx={{
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#333",
                    marginBottom: "4px",
                  }}
                >
                  Select User
                </FormLabel>
                <AutoCompleteSelect
                  name={"user"}
                  placeholder="Select User"
                  value={row.user}
                  handleChange={(event, value, reason) => handleUserChange(event, value, reason)}
                  options={activeUsersList || []}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions 
            sx={{ 
              justifyContent: "flex-end", 
              padding: "16px 24px 24px 24px",
              borderTop: "1px solid #e0e0e0",
              backgroundColor: "#fafafa",
              gap: "12px",
            }}
          >
            <CommonButton
              text="Cancel"
              handleClick={handleAddUserCancelled}
              sx={secondaryButtonStyle}
              hoverColor={primaryButtonHoverColor}
            />
            <CommonButton
              text="Submit"
              handleClick={handleAddUser}
              sx={submitButtonStyle}
              hoverColor={primaryButtonHoverColor}
              disabled={row.user === ""}
            />
          </DialogActions>
        </Dialog>

        <DialogBox
          title="Confirm Deletion"
          body="Are you sure you want to delete this record?"
          confirmText="Confirm"
          isOpen={open}
          onCancel={handleDeleteUserCancelled}
          onConfirm={handleDeleteUserConfirmed}
        />
      </div>
    </>
  );
}